<script>
    export let text, id;
</script>
<div role="alert" id="{id}" aria-live="assertive" aria-atomic="true" class="toast" data-autohide="false">
    <div class="toast-body bg-success text-light">
        {text}
    </div>
</div>